export default __webpack_public_path__ + "static/media/Iso9001.37b11aef.jpeg";